/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSlider as ResolvedStandaloneSlider } from 'base/components/standalone/Slider';

export const Slider: typeof ResolvedStandaloneSlider = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSlider {...props} />
        </ErrorBoundary>
    );
});

export type SliderProps = PropsFromComponent<typeof Slider>;

/** @deprecated Use slot architecture instead */
export const SliderWith = (extras: DynamicStandaloneExtras): typeof Slider => {
    return function Slider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Slider');
        return <ResolvedStandaloneSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}